import { TNewable } from '@ispm/core/interfaces/newable.interface';
import { IWidgetItem } from '@ispm/widgets/interfaces/widget-item.interface';
import { ResolvableService } from '@ispm/core/services/resolvable.service';

/**
 * This Decorator provide dynamic loading of the component via dynamic form.
 * To update the original dynamic form please apply the 'widgetUpdateValueCallback(value)' function.
 *
 * @param aliases
 * @constructor
 */
export function Widget(...aliases: string[]): (contextClass: TNewable<IWidgetItem>) => void {
  return function (contextClass) {
    ResolvableService.Register(contextClass, null, ...aliases);
  };
}
